import { pixelToRemConversion } from '@joykit/helpers/pixelToRemConversion';

export enum SpatialOption {
  default = 'default',
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}
export type SpatialValuesToPixels = { [option in SpatialOption]: number };

/**
 * A set of spacing options.
 *
 * Options are scaled nonlinearly by way of geometric progression, doubling each step.
 *
 * The base number used for generation is `16`.
 *
 * The unit of measurement is: `px`.
 *
 */
export const spatialValues: { [option in SpatialOption]: number } = {
  default: 16,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 32,
  xl: 64
};

export const spatialValuesInRem: { [option in SpatialOption]: string } = {
  default: pixelToRemConversion(spatialValues.md, 16, 'string'),
  xs: pixelToRemConversion(spatialValues.xs, 16, 'string'),
  sm: pixelToRemConversion(spatialValues.sm, 16, 'string'),
  md: pixelToRemConversion(spatialValues.md, 16, 'string'),
  lg: pixelToRemConversion(spatialValues.lg, 16, 'string'),
  xl: pixelToRemConversion(spatialValues.xl, 16, 'string')
};
